import { useState } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";

interface ViewTabsProps {
  onViewChange?: (view: "cards" | "table") => void;
}

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  backgroundColor: "#D6EEF8",
  borderRadius: "9999px",
  padding: "6px 8px", // 🔹 más padding para dar espacio
  display: "flex",
  justifyContent: "center",
  width: "fit-content",
  border: "none",
  gap: 0,
  overflow: "visible", // 🔹 permite que los elementos sobresalgan si es necesario
  "& .MuiToggleButtonGroup-grouped": {
    border: "none !important",
    borderRadius: "9999px !important",
  },
}));

const StyledToggleButton = styled(ToggleButton)(() => ({
  textTransform: "none",
  border: "none !important", // 🔹 sin borde
  borderRadius: "9999px !important",
  fontSize: "0.875rem",
  fontWeight: 600,
  color: "#052649",
  padding: "6px 18px",
  transition: "all 0.25s ease",
  margin: "0 2px", // 🔹 pequeño margen para evitar solapamiento
  position: "relative",
  overflow: "visible", // 🔹 permite que el borde redondeado se vea completo
  "&.Mui-selected": {
    backgroundColor: "#4C7FD6 !important",
    color: "#fff !important",
    zIndex: 2, // 🔹 mayor z-index para estar por encima
    boxShadow: "0 2px 6px rgba(76,127,214,0.3)",
    borderRadius: "9999px !important", // 🔹 fuerza el border-radius
    transform: "scale(1.02)", // 🔹 ligero aumento de tamaño para destacar
    "&:hover": {
      backgroundColor: "#3A6BC3 !important",
    },
  },
  "&:hover": {
    backgroundColor: "rgba(76,127,214,0.1)",
    borderRadius: "9999px !important",
  },
  "&.MuiToggleButtonGroup-grouped": {
    borderRadius: "9999px !important", // 🔹 override de todos los border-radius
    "&:not(:first-of-type)": {
      marginLeft: "0px",
      borderLeft: "none !important",
    },
    "&:not(:last-of-type)": {
      borderRight: "none !important",
    },
    "&:first-of-type": {
      borderRadius: "9999px !important",
    },
    "&:last-of-type": {
      borderRadius: "9999px !important",
    },
  },
}));

export default function ViewTabs({ onViewChange }: ViewTabsProps) {
  const [view, setView] = useState<"cards" | "table">("cards");

  const handleChange = (_event: React.MouseEvent<HTMLElement>, newView: string) => {
    if (newView !== null) {
      const viewType = newView as "cards" | "table";
      setView(viewType);
      onViewChange?.(viewType); // Emite el valor al padre
    }
  };

  return (
    <StyledToggleButtonGroup
      value={view}
      exclusive
      onChange={handleChange}
      aria-label="vista"
    >
      <StyledToggleButton value="cards">Vista Tarjetas</StyledToggleButton>
      <StyledToggleButton value="table">Vista Listado</StyledToggleButton>
    </StyledToggleButtonGroup>
  );
}
